export class DegreeRatesDto {
  DegreeModel: DegreeModel[]=[];
}

export class DegreeModel {
  degreeList :DegreeModelList [] =[]  
}
export class DegreeModelList{
  original? : number = null;
  photocopy? : number = null;
}

export class CopiesTypeModel{
  originalPages:number = 0;
  originalDocValue:number = 0;
  originalAttestationType:number = 0;
  originalDocumentTypeCodeId:number=0;
  originalId:number = null;
  photocopyPages:number = 0;
  photocopyValue:number = 0;
  copyAttestationType:number = 0;
  photoCopyDocumentTypeCodeId:number=0;
  degreeId:number=null;
  photocopyId:number = null;

  constructor(attestation) {
    this.originalPages = attestation.originalPages || 0;
    this.originalDocValue = attestation.originalDocValue || 0;
    this.originalAttestationType = attestation.originalAttestationType || 0;
    this.originalDocumentTypeCodeId = attestation.originalDocumentTypeCodeId || 0;
    this.photocopyPages = attestation.photocopyPages || 0;
    this.photocopyValue = attestation.photocopyValue || 0;
    this.copyAttestationType = attestation.copyAttestationType || 0;
    this.photoCopyDocumentTypeCodeId = attestation.photoCopyDocumentTypeCodeId || 0;
    this.degreeId = attestation.degreeId || null;

  }
}


export class AttestationModel{
  applicationStatus:applicationStatus= new applicationStatus();
  dasApplicationDto:dasApplicationDto = new dasApplicationDto();
  nadraResponseDto:nadraResponseDto = new nadraResponseDto();
  isCheckNadraDetail: boolean;
  id:number =null;
  isPoc:boolean;
  referenceNo:string='';
}

export class applicationStatus {
  label:string='';
  value:number  = null
}

export class nadraResponseDto {
  citizenNumber:string = '';
  code:string = '';
  dob:string = '';
  expiryDate:string = '';
  fatherHusbandName:string = '';
  gender:string = '';
  nadraQueryId:string = '';
  name:string = '';
  permanantAddress:string = '';
  photograph:string = '';
  photographStr:string = '';
  presentAddress:string = '';
  serviceTransactionId:string = '';
  sessionId:string = '';
  signature:string = '';
  signatureStr:string = '';
}

export class dasApplicationDto {
  submittedDate:string;
  applicationAttestationTypeId:number=null;
  isNadraDetailsUpdated:boolean
  applicationStatusCodeId:number = null;
  commonProfileId:number = null;
  id:number = null;
  regionalCentreId:number = null;
  attestationMode:any = null;
  submissionOptionCodeId?:number=null;
  isInsidePakistan?:boolean=false;
  isUrgent:any = null;
  urgentFee:number = 0;
  districtId?:number = null;
  isQuestionnaireFilled:boolean;
  isCheckNadraDetails:boolean;
  noOfOrignalCopies:number = null;
  noOfPhotoCopies:number = null;
  referenceNumber:string='';
  dasDegrees:DasDegrees[]=[new DasDegrees()]
}

export class DasDegrees {
  amount:number = null
  attestationRateId:number = null
  attestationTypeCodeId:number = null
  cpEducationHistoryId:number = null
  dasTranscriptDetails:any
  documentTypeCodeId:number = null
  exactDegreeTitle:string=''
  id:number = null
  isDegreeAttestedBefore:boolean;
  stampNumber:number=null;
  nameOnDegree:string='';
  numberOfPages:number = null
  statusCodeId:number = null
  universityNameOnDegree:string='';
  applicationAttestationTypeId:number;
  educationHistoryDto:educationHistoryDto
  degreeInfo:degreeInfo[]=[new degreeInfo()]
}

export class degreeInfo{
  numberOfPages:number=null;
  id?:number=null;
  attestationRateId:number = null;
  attestationTypeCodeId:number = null;
  documentTypeCodeId:number = null;
  documentTypeCodeValue?:any;
}

export class educationHistoryDto{
  activeIndicator:boolean
  campusTypeId:number = null
  cityId:number = null
  countryId:number = null
  currentEnrolmentInd:boolean
  countryName:string=''
  degreeId:number = null
  verified:boolean;
  degreeProgramName:string=''
  degreeTypeId:number = null
  displaySecuence:number = null
  division:string=''
  eduationHistoryId:number = null
  educationId:number = null
  endDate:number = null
  examSystemTypeCode:number = null
  isIncompleteEducation:boolean
  grade:string='';
  gradingSystemCodeId:number = null
  isResearchWork:number = null
  obtainedCGPAMarks:number = null
  obtainedPercentage:number = null
  otherCampus:string=''
  otherDepartmentName:string=''
  otherFieldOfStudy:number = null
  otherProgramTitle:string=''
  pqfLevelCodeId:number = null
  qualificationId:number = null
  qualificationLevel:string=''
  qualificationLevelCode:number = null
  registrationNumber:string=''
  sessionTypeId:number = null
  specializationSubjectId:number = null
  startDate:number = null
  subjectId:number = null
  subjectName:string=''
  totalCGPAMarks:number = null
  universityId:number = null
  universityName:string='';
  isPartiallyAttested:boolean;
  isCAUniversity:boolean;

}